import SelectBinder from './SelectBinder';

export default class MultiSelectBinder extends SelectBinder {
	initEvents() {
		this.baseElement.addEventListener('change', (e) => {
			const selectedOptions = Array.from(e.target.selectedOptions).map(
				(option) => option.value
			);
			this.isActive = selectedOptions.includes(this.optionValue);
			this.handleChange();
		});

		super.initEvents();
	}
}
